













import { Mixins, Component, Prop, Watch, Emit } from "vue-property-decorator";
import { EditorItemMixin } from "./mixins";
import { WorkflowPhaseEditorModel } from "../../../../domain/workflow/editor";
import { PhaseStatusKinds } from "../../../../domain/workflow/kinds";
import DatePicker from "../../../system/selectors/DatePicker.vue";
import { ReceptionDateTranslator } from "../../../../domain/workflow";

@Component({
  components: {
    DatePicker,
  }
})
export default class WorkflowPhaseEditor extends Mixins(EditorItemMixin) {
  @Prop()
  isRegistered: boolean;

  @Prop()
  detailId: number;

  @Prop()
  formatId: number;

  @Prop()
  phase: WorkflowPhaseEditorModel;

  @Prop()
  phaseMasterLimitDays: number;

  @Prop()
  baseDate: Date;

  _dateTranslator: ReceptionDateTranslator;
  _isLinkedDateUpdating: boolean = false;

  @Watch("baseDate") // propの更新を監視
  onBaseDateUpdated(newValue: Date, oldValue: Date) {
    if (!newValue || newValue.valueOf() === oldValue.valueOf() || this._isLinkedDateUpdating) {
      return;
    }
    console.log("calc limitDate when onBaseDateUpdated");
    this.calcLimitDate();
  }

  @Watch("phaseMasterLimitDays")
  onPhaseMasterUpdated(newValue: number, oldValue: number) {
    if (newValue === oldValue) {
      return;
    }
    console.log("onPhaseMasterLimitDaysUpdated");
    this.calcLimitDate();
  }

  @Watch("formatId")
  onFormatUpdated(newValue: number, oldValue: number) {
    if (newValue === oldValue) {
      return;
    }

    console.log("onFormatUpdated");
    this.calcLimitDate();
  }

  @Emit()
  update(phase: WorkflowPhaseEditorModel): void {}

  @Emit()
  selectedLinkedDate(diffDays: number): void {}

  created(): void {
    this._dateTranslator = new ReceptionDateTranslator();
  }

  mounted(): void {
    console.log("mounted!");
    if (!this.limitDate && !this.detailId) {
      this.calcLimitDate();
    }
  }

  // 締切日を計算
  private calcLimitDate(): void {
    if (!this.limitDays) { // 締切日数が未指定
      // this.limitDate = null;
      return;
    }
    console.log("calcLimitDate");

    this.limitDate = this._dateTranslator.addDays(
      this.baseDate,
      this.limitDays
    );
  }

  async selectLinkedDate(): Promise<void> {
    const result = await this.$commonDialogs.date.dateSelector.show(this.limitDate);
    if (result === undefined) { return; } // 日付選択を中止する場合

    const diffDays = this._dateTranslator.durationDays(this.limitDate, result);
    if (!diffDays) {
      this.limitDate = null;
      return;
    } // 日付を未選択にする場合
    this.selectedLinkedDate(diffDays);
  }

  // 連動選択により自動で締切日を伸ばすときに親から呼ばれる
  setLimitDate(date: Date): void {
    this.limitDate = date;
  }

  setLinkedDateUpdating(): void {
    if (this._isLinkedDateUpdating) { return; }
    this._isLinkedDateUpdating = true;
    this.$nextTick(() => {
      this._isLinkedDateUpdating = false;
    });
  }

  get limitDays(): number {
    return this.phase.limitDays;
  }

  set limitDays(value: number) {
    const cloned = this.phase.clone();
    cloned.limitDays = value;
    this.update(cloned);
  }

  get durationDays(): string {
    const days = this._dateTranslator.durationDays(
      this.baseDate,
      this.limitDate
    );
    if (days == null) {
      return "";
    }
    return days + "日後";
  }

  get limitDate(): Date {
    return this.phase.limitDate;
  }

  set limitDate(value: Date) {
    const cloned = this.phase.clone();
    cloned.limitDate = value;
    this.update(cloned);
  }

  get isEnable(): boolean {
    return this.phase.isEnable;
  }

  set isEnable(value: boolean) {
    const cloned = this.phase.clone();
    cloned.isEnable = value;
    this.update(cloned);
  }

  get isReadonly(): boolean {
    return this.phase.phaseStatus === PhaseStatusKinds.Done;
  }

  get isLimitButtonEnable(): boolean {
    return !this.isReadonly && !!this.limitDate;
  }
}
